<template>
  <div class="message-template clearfix">
    <div class="person-icon"></div>
    <div class="message-container">
      <div class="triangle"></div>
      <div class="message">
        <div class="message-header">若未解决您的问题,请选择人工客服</div>
        <div id="_umfp" style="display:inline;width:1px;height:1px;overflow:hidden">
        </div>
        <div id="dom_id" class="nc-container"></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .message-template .message-container {
    width: 250px;
  }
</style>
<script>
    import NoCaptcha from 'no-captcha'
    export default{
      data(){
        return{
          isCheck: {}
        }
      },
      components:{
      },
      ready() {
        var me = this;
        var csessionid, sig;
        var nc = new noCaptcha({
          renderTo: '#dom_id',
          appkey: 'CF_APP_1',
          scene: 'login',
          token:'PX3G0Q0XL2YO7WPEXSCDJGXKBPOFQK2O',
          callback: function(data) {

            var sendData = {
              csessionid: data.csessionid,
              sig: data.sig,
              appKey: 'CF_APP_1',
              token: 'PX3G0Q0XL2YO7WPEXSCDJGXKBPOFQK2O',
              ip: '192.168.1.142'
            };

            me.$http
              .jsonp('http://webim.daily.taobao.net/visitor/visitorGenerator.do',{
                params: sendData
              })
              .then((res) => {return res.json();})
              .then((o) => {
                me.isCheck.userName = o.data.userName;
                me.isCheck.userId = o.data.userId;
                me.isCheck.xcode = o.data.xcode;
                me.$dispatch('is-check', me.isCheck);
              });
          }
        });

        nc.upLang('cn', {
          _startTEXT: "向右滑动验证切换人工",
          _yesTEXT: "<b>验证通过</b>",
          _Loading: "正在加载..."
        });
      },
    }
</script>



// WEBPACK FOOTER //
// VisitorCheck.vue?7c945af7